import { Component, OnInit } from '@angular/core';
import { Platform, AlertController, NavController, MenuController, NavParams } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { RapportService } from '../../app/shared/services/rapport.service';
import { AuthService } from '../../app/shared/services/auth.service';
import { LastScansService } from '../../app/shared/services/lastScans.service';

import { ListeObservationsRapportComponent } from '../liste-observations-rapport/liste-observations-rapport';
import { HomepageComponent } from '../home/home';

@Component({
    selector: 'page-rapport',
    templateUrl: './rapport.html'
})
export class RapportComponent implements OnInit {
    user: string = '';
    rapport = { rapportId: 0 };
    rapportId: number = 0;
    loader: boolean = true;

    constructor(
    private iab: InAppBrowser,
     private platform: Platform,
     private ga: GoogleAnalytics,
     private rapportService: RapportService,
     private alertCtrl: AlertController,
     private navCtrl: NavController,
     private menuCtrl: MenuController,
     private authService: AuthService,
     private lastScansService: LastScansService,
     private navParams: NavParams
    ) {
        this.platform.ready().then(() => {
            this.ga.trackView("Rapport");
        });
    }

    ngOnInit() {
        this.init();
    }

    async init(): Promise<any> {
        this.rapportId = this.navParams.get("rapportId") || 0;
        if (this.rapportId === 0 || this.rapportId === null) {
            const liste = await this.lastScansService.getLastScans();
            const token = await this.authService.getToken();
            this.user = (token !== null) ? token.user : '';
            if (liste !== null) {
                for(let i in liste) {
                    if (liste[i].user === this.user) {
                        this.rapport = (liste[i].scans !== null) ? liste[i].scans[0].data : { rapportId: 0 };
                        this.rapportId = this.rapport.rapportId;
                        this.loader = false;
                    }
                }
            }
        } else {
            this.getRapport();
        }
    }

    getRapport(): any {
        this.rapportService.getRapport(this.rapportId).subscribe((rapport: any) => {
                this.rapport = rapport;
                this.loader = false;
            },
            async (error: any) => {
                console.error(error);
                if (error.status === 401 && !this.authService.refreshCalled) {
                    this.authService.refreshCalled = true;
                    const refreshToken = await this.authService.getRefreshToken();
                    if (refreshToken === null) {
                        await this.authService.removeToken();
                        await this.authService.removeRefreshToken();
                        this.menuCtrl.enable(true, 'unauthenticated');
                        this.menuCtrl.enable(false, 'authenticated');
                        this.navCtrl.setRoot(HomepageComponent);
                    } else {
                        this.authService.refresh(refreshToken).subscribe(async (data: any) => {
                            const token = await this.authService.getToken();
                            await this.authService.setToken(token.user, data.access_token, data.statut);
                            await this.authService.setRefreshToken(data.refresh_token)
                            this.navCtrl.setRoot(RapportComponent, { rapportId: this.rapportId });
                        });
                    }
                } else {
                    this.authService.refreshCalled = false;
                    this.navCtrl.setRoot(HomepageComponent);
                }
            }
        );
    }

    goToListeObservations(id: number): any {
        this.navCtrl.push(ListeObservationsRapportComponent, { rapportId: id });
    }

    goToPdf(rapport: any): any {
        if (rapport.pdfLimitExceeded) {
            const alert = this.alertCtrl.create({
                title: 'Taille excédée',
                subTitle: 'Ce rapport de ' + Math.round(rapport.pdfSize * 100)/100 + 'Mo ne peut pas être téléchargé car il dépasse la taille maximale autorisée de ' + rapport.pdlLimitSize + 'Mo. Nous vous invitons à le consulter sur l\'extranet SOCOTEC Avantage via votre navigateur.',
                buttons: ['D\'accord']
            });
            alert.present();
        } else {
            this.platform.ready().then(_ => {
                this.ga.trackEvent("PDF", "click");
            });
            this.iab.create(encodeURI(rapport.pdfURL), '_system', 'location=yes');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/rapport/rapport.ts